import React from 'react';
import { Props } from './interfaces';
import './Steps.scss';
import './Steps-media.scss';
import Title from '../Title/Title';

const Steps = ({ title, text, list }: Props) => {
  return (
    <>
      <Title center title={title} text={text} marginBottom={!text ? 60 : 0} />
      <div className="steps">
        {list.map(({ title, text }, i) => (
          <div className="steps__item" key={i}>
            <div className="steps__text">
              <h4>{title}</h4>
              {text ? <p className="body2">{text}</p> : null}
              <h2 className="steps__num">{i + 1}</h2>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Steps;
